// extracted by mini-css-extract-plugin
export var lineLink = "SectionTitle-module--line-link--hVxv0";
export var lineLink_black = "SectionTitle-module--line-link_black--X72ij";
export var lineLink_grey = "SectionTitle-module--line-link_grey--G4QO9";
export var lineLink_primary = "SectionTitle-module--line-link_primary--B--qc";
export var lineLink_secondary = "SectionTitle-module--line-link_secondary--z1+rX";
export var lineLink_white = "SectionTitle-module--line-link_white--FInFz";
export var title = "SectionTitle-module--title--Mz2TZ";